const prefix = 'nxt';
const iconName = 'ToggleSmallView';
const width = 16;
const height = 16;
const ligatures = [];
const unicode = '';
const svgPathData =
  'M8.5128 0C7.40823 0 6.5128 0.895434 6.5128 2.00001V7.4815C6.5128 8.58608 7.40824 9.48151 8.5128 9.48151H13.9943C15.0989 9.48151 15.9943 8.58607 15.9943 7.4815V2.00001C15.9943 0.895433 15.0989 0 13.9943 0H8.5128ZM3.97191 2.13547L3.97198 2.11858H3.00586C1.34901 2.11858 0.00585938 3.46173 0.00585938 5.11859V13C0.00585938 14.6569 1.34901 16 3.00586 16H10.8872C12.5441 16 13.8872 14.6568 13.8872 13V12.0338L13.8702 12.0338H12.3872V13C12.3872 13.8284 11.7157 14.5 10.8872 14.5H3.00586C2.17743 14.5 1.50586 13.8284 1.50586 13V5.11859C1.50586 4.29016 2.17743 3.61858 3.00586 3.61858H3.97191V2.13547Z';
const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtToggleSmallView = definition;

export { definition, nxtToggleSmallView, prefix, iconName, width, height, ligatures, unicode, svgPathData };
